import styled from 'styled-components';
import colors from 'constants/colors';
import Resizer from 'assets/svg/Resizer.svg'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  color: ${colors.white};

  .label {
    font-size: 13px;
    font-weight: 600;
    color: ${colors.silver};
    letter-spacing: 1px;
    margin-bottom: 5px;
    white-space: nowrap;
  }

  textarea {
    min-height: 144px;
    resize: ${(props) => (props.resize? props.resize: 'none')};
    overflow: auto;
    color: ${colors.white};
    background-color: ${(props) => (props.mainPage ? 'transparent' : colors.black2)};
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    padding: 9px;
    border: 1px solid ${colors.darkGrey};
    width: 100%;

    ::-webkit-resizer {
      background: url(${Resizer});
    }

    :focus-visible {
      outline: none;
      background-color: ${colors.black1};
    }
  }

  textarea::placeholder {
    font-weight: 300;
    font-style: italic;
    letter-spacing: 1px;
    color: ${colors.white};
  }

  .warning {
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: ${colors.red};
    font-size: 14px;
    font-weight: 600;
    white-space: normal;
    word-wrap: break-word; 
    word-break: break-all;
    overflow: visible;
    text-align: left;
    margin-top: 5px;
  }

  .description {
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: ${colors.white};
    font-size: 14px;
    font-weight: 600;
    white-space: normal;
    word-wrap: break-word; 
    word-break: break-all;
    overflow: visible;
    text-align: left;
    margin-top: 5px;
  }

  ${(props) => props.additionalstyle};
`;
